// Simple draft manager for chat messages
class DraftManager {
  constructor() {
    this.drafts = new Map();
  }

  saveDraft(chatId, message) {
    if (message.trim()) {
      this.drafts.set(chatId, message);
    } else {
      this.drafts.delete(chatId);
    }
  }

  getDraft(chatId) {
    return this.drafts.get(chatId) || '';
  }

  clearDraft(chatId) {
    this.drafts.delete(chatId);
  }
}

export const draftManager = new DraftManager();